import allTransactionsRoute from "./list-all-transactions-route";
import approvePayoutRequest from "./approve-payout-request-route";
import listTransactionsRoute from "./list-transactions-route";
import walletBalanceRoute from "./wallet-balance-route";

export default {
  "list-transactions": listTransactionsRoute,
  "wallet-balance": walletBalanceRoute,
  "approve-payout-request": approvePayoutRequest,
  "list-all-transactions": allTransactionsRoute,
};
